import React from 'react';
import { RocketIcon, LandmarkIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { pillars } from '../data/content';
const icons = [RocketIcon, LandmarkIcon];
export function SolutionSection() {
  return <section className="relative w-full overflow-hidden bg-navy-800 py-[21px] lg:py-20" aria-labelledby="solution-heading" data-id="element-187" data-mp="3oabybomzuclm">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 grid-pattern opacity-60" data-id="element-188" data-mp="3j8waxpxcfu02" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8" data-id="element-189" data-mp="12hy5uat9q39">
        <Reveal className="max-w-3xl" data-id="element-190" data-mp="3t7byxk12qn5c">
          <h2 id="solution-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-191" data-mp="3t6anheg5byn3">
            The complete AI transformation system for modern agents
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-192" data-mp="ksld7o76ry9h">
            Not a course. Not theory. A proven five-part operational system — with five high-value bonuses — that
            runs your business while you sell.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-193" data-mp="36c6ync2o0h1t">
          {pillars.map((pillar, i) => {
          const Icon = icons[i];
          return <Reveal key={pillar.title} delay={i * 0.06} className="h-full" data-id="element-194" data-mp="3fbk5dwzemriu" data-mpi={i}>
                <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-8 transition-[background-color,border-color] duration-200 ease-out hover:border-white/20 hover:bg-white/[0.07]" data-id="element-195" data-mp="3fdn5j9u9u11a">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-gold/15 text-brand-gold" data-id="element-196" data-mp="3u81gcn3om44v">
                    <Icon aria-hidden="true" className="h-6 w-6" strokeWidth={1.75} data-id="element-197" data-mp="2v6rcdgl8af4" />
                  </span>
                  <h3 className="mt-6 text-xl font-bold text-white" data-id="element-198" data-mp="6uz7pcc83kv1">{pillar.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-199" data-mp="bvwkf9egrmp5">{pillar.description}</p>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}